module.exports = __webpack_public_path__ + "static/media/voxwizard-logo.664648b1.jpg";